import * as yup from "yup";
import { TimeSlotTask } from "Models/time.slot.task";
import { Translate } from "Components/Generic/UploadCSVFile/types";
import { TaskStartDatePeriod } from "Models/task";

export const createTaskValidationSchema = (params: {
  translate: Translate;
  formatWithUserTimezone: (date: Date | string | number, formatText: string) => string;
}) => {
  const { translate, formatWithUserTimezone } = params;
  const schema = yup.object().shape({
    type: yup
      .string()
      .required(translate("thisFieldIsRequired"))
      .typeError(translate("thisFieldIsRequired")),
    timeSlots: yup.array().when("isMultiDayTask", {
      is: true,
      then: yup.array().when("period", {
        is: TaskStartDatePeriod.VARIABLE_TIME,
        then: yup
          .array()
          .min(2, translate("itShouldBeAtLeastTwoDates"))
          .of(
            yup.object().shape({
              date: yup
                .string()
                .required(translate("thisFieldIsRequired"))
                .typeError(translate("thisFieldIsRequired")),
              from: yup
                .string()
                .required(translate("thisFieldIsRequired"))
                .typeError(translate("thisFieldIsRequired")),
              to: yup
                .string()
                .required(translate("thisFieldIsRequired"))
                .test(
                  "end-time-greater-than-start-time",
                  translate("endTimeMustBeGreaterThanStartTime"),
                  function (value) {
                    const { date, from } = this.parent;
                    if (!from || !value) return true;

                    const currentDate = date.split("T")[0];
                    const startTime = new Date(`${currentDate}T${from}`);
                    const endTime = new Date(`${currentDate}T${value}`);

                    return endTime > startTime;
                  }
                ),
            })
          )
          .typeError(translate("thisFieldIsRequired")),
        otherwise: yup.array().nullable(),
      }),
      otherwise: yup.array().nullable(),
    }),
    startDate: yup.date().when("timeSlots", {
      is: (value: TimeSlotTask[]) => value?.length === 0,
      then: yup
        .date()
        .required(translate("thisFieldIsRequired"))
        .typeError(translate("thisFieldIsRequired")),
      otherwise: yup.date().nullable(),
    }),
    endDate: yup.date().when("isMultiDayTask", {
      is: true,
      then: yup.date().when("timeSlots", {
        is: (value: TimeSlotTask[]) => value?.length === 0,
        then: yup
          .date()
          .required(translate("thisFieldIsRequired"))
          .typeError(translate("thisFieldIsRequired")),
        otherwise: yup.date().nullable(),
      }),
      otherwise: yup.date().nullable(),
    }),
    startTime: yup.string().when(["timeSlots", "period"], {
      is: (timeSlots: TimeSlotTask[], period: TaskStartDatePeriod) =>
        timeSlots?.length === 0 && period !== TaskStartDatePeriod.MULTI_DAY,
      then: yup
        .string()
        .required(translate("thisFieldIsRequired"))
        .typeError(translate("thisFieldIsRequired")),
      otherwise: yup.string().nullable(),
    }),
    endTime: yup.string().when(["timeSlots", "period"], {
      is: (timeSlots: TimeSlotTask[], period: TaskStartDatePeriod) =>
        timeSlots?.length === 0 && period !== TaskStartDatePeriod.MULTI_DAY,
      then: yup
        .string()
        .required(translate("thisFieldIsRequired"))
        .test(
          "end-time-greater-than-start-time",
          translate("endTimeMustBeGreaterThanStartTime"),
          function (value) {
            const { startDate, startTime: from } = this.parent;
            if (!from || !value) return true;

            const currentDate = formatWithUserTimezone(new Date(startDate), "yyyy-MM-dd");
            const startTime = new Date(`${currentDate}T${from}`);
            const endTime = new Date(`${currentDate}T${value}`);

            console.debug("AQUIII", startTime, endTime);

            return endTime > startTime;
          }
        )
        .typeError(translate("thisFieldIsRequired")),
      otherwise: yup.string().nullable(),
    }),
  });
  return schema;
};
